<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-between align-items-center "
        >
          <h3 class="ml-1 mb-0">
            النقاط الثابتة
          </h3>
          <div class="d-flex gap-2">
            <b-button
              variant="info"
              @click="viewMap"
            >
              <feather-icon
                icon="MapIcon"
                size="14"
                class="mr-1"
              />
              عرض على الخريطة
            </b-button>
            <b-button
              variant="primary"
              @click="showAddModal"
            >
              <feather-icon
                icon="PlusIcon"
                size="14"
                class="mr-1"
              />
              إضافة نقطة ثابتة
            </b-button>
          </div>
        </b-col>
        <!-- Filters -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filter.search"
            placeholder="بحث بالكود أو المستوى"
            @input="handleSearch"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.accuracy_degree"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="accuracyDegreeOptions"
            :reduce="(val) => val.value"
            placeholder="درجة الدقة"
            label="label_ar"
            @input="handleFilterChange"
          >
            <template #option="{ label_ar }">
              <span>{{ label_ar }}</span>
            </template>
            <template #selected-option="{ label_ar }">
              <span>{{ label_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <!-- Location filters -->
        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.governorate_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="governorates.data || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="المحافظة"
            @search="onGovernorateSearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.center_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="centers.data || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="الجهاز / الحي / المركز"
            @search="onCenterSearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.city_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="cities.data || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="الوحدة المحلية / المدينة"
            @search="onCitySearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.district_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="districts.data || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="القرية / التجمع"
            @search="onDistrictsSearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.village_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="villages.data || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="عزبة / نجع / منطقة"
            @search="onVillageSearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.responsible_employee_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="employees.data || []"
            :reduce="(val) => val.id"
            :get-option-label="(option) => option.full_name"
            placeholder="الموظف المسؤول"
            @search="callEmployees"
            @input="handleFilterChange"
          >
            <template #option="{ full_name }">
              <span>{{ full_name }}</span>
            </template>
            <template #selected-option="{ full_name }">
              <span>{{ full_name }}</span>
            </template>
          </v-select>
        </b-col>

        <!-- <b-col cols="12" md="3">
          <b-form-input
            v-model.number="filter.level"
            type="number"
            placeholder="المستوى"
            @input="handleFilterChange"
          />
        </b-col> -->
      </b-row>
    </b-card>

    <!-- Table -->
    <b-card class="mt-1">

      <b-spinner
        v-if="load"
        class="d-block text-center my-4"
      />
      <b-table
        v-else
        :items="fixedPointsItems"
        :fields="fields"
        responsive
        striped
        hover
        :per-page="fixedPoints.per_page"
        :current-page="fixedPoints.current_page"
      >
        <template #cell(code)="row">
          <strong>{{ row.item.code }}</strong>
        </template>

        <template #cell(description)="row">
          {{ row.item.description || '-' }}
        </template>

        <template #cell(coord_type)="row">
          <p
            v-if="row.item.coord_type"
            variant="info"
          >
            {{ getCoordTypeLabel(row.item.coord_type) }}
          </p>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>
        <template #cell(correction_type)="row">
          <p class="mb-0">
            {{ getCorrectionTypeLabel(row.item.correction_type) }}
          </p>
        </template>

        <template #cell(coordinates)="row">
          <div v-if="row.item.latitude && row.item.longitude">
            <small>
              <strong>Lat:</strong> {{ row.item.latitude }}<br>
              <strong>Lng:</strong> {{ row.item.longitude }}
            </small>
          </div>
          <div v-else-if="row.item.utm_est && row.item.utm_north">
            <small>
              <strong>UTM E:</strong> {{ row.item.utm_est }}<br>
              <strong>UTM N:</strong> {{ row.item.utm_north }}
            </small>
          </div>
          <div v-else-if="row.item.etm_est && row.item.etm_north">
            <small>
              <strong>ETM E:</strong> {{ row.item.etm_est }}<br>
              <strong>ETM N:</strong> {{ row.item.etm_north }}
            </small>
          </div>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>

        <template #cell(location)="row">
          <small>
            <span v-if="row.item.governorate_id">
              <strong>المحافظة:</strong> {{ row.item.governorate_id }}
            </span>
            <br v-if="row.item.center_id">
            <span v-if="row.item.center_id">
              <strong>الجهاز/المركز:</strong> {{ row.item.center_id }}
            </span>
            <br v-if="row.item.city_id">
            <span v-if="row.item.city_id">
              <strong>المدينة:</strong> {{ row.item.city_id }}
            </span>
            <br v-if="row.item.district_id">
            <span v-if="row.item.district_id">
              <strong>القرية/التجمع:</strong> {{ row.item.district_id }}
            </span>
            <br v-if="row.item.village_id">
            <span v-if="row.item.village_id">
              <strong>عزبة/نجع/منطقة:</strong> {{ row.item.village_id }}
            </span>
            <span
              v-if="!row.item.governorate_id && !row.item.center_id && !row.item.city_id && !row.item.district_id && !row.item.village_id"
              class="text-muted"
            >
              -
            </span>
          </small>
        </template>

        <!-- <template #cell(level)="row">
          {{ row.item.level || '-' }}
        </template> -->

        <template #cell(accuracy_degree)="row">
          <b-badge
            :style="{
              backgroundColor: row.item.accuracy_degree_color,
              color: 'white',
            }"
          >
            {{ row.item.accuracy_degree_label_ar }}
          </b-badge>
        </template>

        <template #cell(responsible_employee)="row">
          {{ row.item.responsible_employee ? row.item.responsible_employee.full_name : '-' }}
        </template>

        <template #cell(creator)="row">
          {{ row.item.creator ? row.item.creator.name : '-' }}
        </template>

        <template #cell(media)="row">
          <div
            v-if="row.item.media && row.item.media.length > 0"
            class="d-flex gap-1"
          >
            <b-avatar
              v-for="mediaItem in row.item.media.slice(0, 3)"
              :key="mediaItem.id"
              v-b-tooltip.hover.top="mediaItem.name"
              :src="mediaItem.url"
              size="32px"
            />
            <span
              v-if="row.item.media.length > 3"
              class="text-muted"
            >
              +{{ row.item.media.length - 3 }}
            </span>
          </div>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>

        <template #cell(created_at)="row">
          {{ formatDate(row.item.created_at) }}
        </template>

        <template #cell(actions)="row">
          <div class="d-flex gap-2">
            <b-button
              v-b-tooltip.hover.top="'عرض'"
              variant="outline-info"
              size="sm"
              @click="viewFixedPoint(row.item)"
            >
              <feather-icon
                icon="EyeIcon"
                size="14"
              />
            </b-button>
            <b-button
              v-b-tooltip.hover.top="'تعديل'"
              variant="outline-primary"
              size="sm"
              @click="editFixedPoint(row.item)"
            >
              <feather-icon
                icon="EditIcon"
                size="14"
              />
            </b-button>
            <b-button
              v-b-tooltip.hover.top="'حذف'"
              variant="outline-danger"
              size="sm"
              @click="confirmDelete(row.item)"
            >
              <feather-icon
                icon="TrashIcon"
                size="14"
              />
            </b-button>
          </div>
        </template>
      </b-table>

      <!-- Pagination -->
      <b-pagination
        v-if="fixedPoints.last_page > 1"
        v-model="fixedPoints.current_page"
        :total-rows="fixedPoints.total"
        :per-page="fixedPoints.per_page"
        align="center"
        class="mt-3"
        @change="onPageChange"
      />
    </b-card>

    <!-- Add/Edit Modal -->
    <FixedPointForm
      :show="showFormModal"
      :fixed-point="selectedFixedPoint"
      @close="closeFormModal"
      @saved="handleSaved"
    />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BButton,
  BSpinner,
  BPagination,
  BFormInput,
  BBadge,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import FixedPointForm from './FixedPointForm.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BSpinner,
    BPagination,
    BFormInput,
    BBadge,
    BAvatar,
    vSelect,
    FeatherIcon,
    FixedPointForm,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      fixedPoints: 'fixedPoints/fixedPoints',
      load: 'fixedPoints/load',
      employees: 'employees/employees',
      governorates: 'governorates/governorates',
      centers: 'centers/centers',
      cities: 'cities/cities',
      districts: 'districts/districts',
      villages: 'villages/districts',
      accuracyDegrees: 'settings/accuracyDegrees',
      loadAccuracyDegrees: 'settings/loadAccuracyDegrees',
    }),
    accuracyDegreeOptions() {
      return this.accuracyDegrees
    },
    fixedPointsItems() {
      if (Array.isArray(this.fixedPoints)) return this.fixedPoints
      if (Array.isArray(this.fixedPoints?.data)) return this.fixedPoints.data
      if (Array.isArray(this.fixedPoints?.data?.data)) return this.fixedPoints.data.data
      return []
    },
  },
  data() {
    return {
      showFormModal: false,
      selectedFixedPoint: null,
      filter: {
        search: null,
        accuracy_degree: null,
        responsible_employee_id: null,
        level: null,
        governorate_id: null,
        center_id: null,
        city_id: null,
        district_id: null,
        village_id: null,
      },
      fields: [
        { key: 'code', label: 'الكود', sortable: true },
        // { key: 'description', label: 'الوصف' },
        // { key: 'location', label: 'الموقع' },
        { key: 'coord_type', label: 'نوع الإحداثيات' },
        { key: 'correction_type', label: 'نوع التصحيح' },
        { key: 'coordinates', label: 'الإحداثيات' },
        { key: 'level', label: 'المستوى', sortable: true },
        { key: 'accuracy_degree', label: 'درجة الدقة' },
        { key: 'responsible_employee', label: 'الموظف المسؤول' },
        { key: 'creator', label: 'بواسطة' },
        // { key: 'media', label: 'الملفات' ,width: '10%'},
        { key: 'created_at', label: 'تاريخ الإنشاء', sortable: true },
        { key: 'actions', label: 'الإجراءات', width: '15%' },
      ],
    }
  },
  mounted() {
    this.init()
    this.listAccuracyDegrees()
  },
  methods: {
    init() {
      this.loadFixedPoints()
      this.$store.dispatch('employees/listEmployees', { query: {} })
    },
    listAccuracyDegrees() {
      this.$store.dispatch('settings/listAccuracyDegrees', {})
    },
    loadFixedPoints() {
      const query = {
        page: this.fixedPoints.current_page,
        per_page: this.fixedPoints.per_page,
        ...this.filter,
      }
      // Remove null values
      Object.keys(query).forEach(key => {
        if (query[key] === null || query[key] === '') {
          delete query[key]
        }
      })
      this.$store.dispatch('fixedPoints/listFixedPoints', { query })
    },
    handleSearch() {
      // Debounce search
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.fixedPoints.current_page = 1
        this.loadFixedPoints()
      }, 500)
    },
    handleFilterChange() {
      this.fixedPoints.current_page = 1
      this.loadFixedPoints()
    },
    onPageChange(page) {
      this.fixedPoints.current_page = page
      this.loadFixedPoints()
    },
    showAddModal() {
      this.selectedFixedPoint = null
      this.showFormModal = true
    },
    editFixedPoint(fixedPoint) {
      this.selectedFixedPoint = fixedPoint
      this.showFormModal = true
    },
    viewFixedPoint(fixedPoint) {
      // Navigate to detail view or show in modal
      this.$router.push({
        name: 'fixed-point-details',
        params: { id: fixedPoint.id },
      })
    },
    viewMap() {
      this.$router.push({
        name: 'fixed-points-map',
      })
    },
    closeFormModal() {
      this.showFormModal = false
      this.selectedFixedPoint = null
    },
    handleSaved() {
      this.closeFormModal()
      this.loadFixedPoints()
      this.$toast.success('تم الحفظ بنجاح')
    },
    confirmDelete(fixedPoint) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف النقطة الثابتة بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch('fixedPoints/deleteFixedPoint', fixedPoint.id)
            .then(() => {
              this.$swal('تم الحذف!', 'تم حذف النقطة الثابتة.', 'success')
              this.loadFixedPoints()
            })
            .catch(err => {
              this.$swal(
                'خطأ!',
                err?.response?.data?.message || 'حدث خطأ أثناء الحذف',
                'error',
              )
            })
        }
      })
    },
    callEmployees(search) {
      const query = search ? { search } : {}
      this.$store.dispatch('employees/listEmployees', { query })
    },
    onGovernorateSearch(search) {
      const params = search ? { search } : {}
      this.$store.dispatch('governorates/list', params)
    },
    onCenterSearch(search) {
      const params = search ? { search } : {}
      this.$store.dispatch('centers/list', params)
    },
    onCitySearch(search) {
      const params = search ? { search } : {}
      this.$store.dispatch('cities/list', params)
    },
    onDistrictsSearch(search) {
      const params = search ? { search } : {}
      this.$store.dispatch('districts/list', params)
    },
    onVillageSearch(search) {
      const params = search ? { search } : {}
      this.$store.dispatch('villages/list', params)
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('ar-EG')
    },
    getCoordTypeLabel(coordType) {
      const labels = {
        lat_lon: 'خطوط الطول والعرض',
        etm: 'ETM',
        utm: 'UTM',
      }
      return labels[coordType] || coordType
    },
    getCorrectionTypeLabel(correctionType) {
      return correctionType === 'after' ? 'بعد التصحيح' : 'قبل التصحيح'
    },
  },
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 1rem;
}
</style>
